import api from 'common/api';

export const searchNotificationAPI = (params: any) => api.get('/notification/list', params);

export const updateKdkFlgAPI = (params: any) => api.post('/notification/updateKdkFlg', params);

export const updateKdkFlgDetailAPI = (params: any) => api.post('/notification/updateKdkFlgDetail', params);

export const updateKdkFlgDetailsAPI = (params: any) => api.post('/notification/updateKdkFlgDetails', params);

export const detailNotificationAPI = (params: any) => api.get('/notification/detail', params);

export const updateNotificationAPI = (params: any) => api.put('/notification', params);
